// extracted by mini-css-extract-plugin
module.exports = {"indicator":"Indicator_indicator__3mxGE","hasExpired":"Indicator_hasExpired__13FqE","aboutToExpire":"Indicator_aboutToExpire__lzgH0"};